import { render, staticRenderFns } from "./CheckSmall.vue?vue&type=template&id=4b0f8804&scoped=true&lang=pug"
import script from "./CheckSmall.vue?vue&type=script&lang=js"
export * from "./CheckSmall.vue?vue&type=script&lang=js"
import style0 from "./CheckSmall.vue?vue&type=style&index=0&id=4b0f8804&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0f8804",
  null
  
)

export default component.exports